import * as React from "react";
import type { Subtract } from "utility-types";
import { CredentialsConsumer } from "../chrome/smart/app-container/app-container-lib";
import type { AppCredentials } from "../chrome/smart/app-container/app-container-types";

export interface WithCredentialsProps {
    credentials: AppCredentials;
}

export const withCredentials = <P extends WithCredentialsProps>(Component: React.ComponentType<P>) =>
    class WithAppID extends React.Component<Subtract<P, WithCredentialsProps>> {
        public render() {
            return (
                <CredentialsConsumer>
                    {creds => <Component {...(this.props as P)} credentials={creds} />}
                </CredentialsConsumer>
            );
        }
    };
